var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 36925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_i_2670_49993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.14466 20.4406C5.11849 20.5789 4.1646 19.8894 3.97969 18.8758L3.75226 17.6292C3.68709 17.2719 3.46193 16.9636 3.14051 16.7915L2.01901 16.1911C1.10712 15.703 0.742762 14.5874 1.19206 13.6592L1.74463 12.5177C1.90299 12.1905 1.90299 11.8095 1.74463 11.4823L1.19206 10.3408C0.742762 9.41262 1.10712 8.29706 2.01901 7.80888L3.14051 7.20848C3.46193 7.03641 3.68709 6.7281 3.75226 6.37083L3.97969 5.1242C4.1646 4.11058 5.11849 3.42112 6.14466 3.5594L7.40672 3.72945C7.76842 3.77819 8.13274 3.66043 8.39656 3.4095L9.31711 2.53394C10.0656 1.82203 11.2447 1.82203 11.9932 2.53394L12.9137 3.4095C13.1775 3.66043 13.5419 3.77819 13.9036 3.72945L15.1656 3.5594C16.1918 3.42112 17.1457 4.11058 17.3306 5.1242L17.3517 5.24012C17.5473 6.31193 18.2228 7.23684 19.187 7.75305L19.2913 7.80888C20.2032 8.29706 20.5675 9.41262 20.1182 10.3408L19.5656 11.4823C19.4073 11.8095 19.4073 12.1905 19.5656 12.5177L20.1182 13.6592C20.5675 14.5874 20.2032 15.703 19.2913 16.1911L18.1698 16.7915C17.8484 16.9636 17.6232 17.2719 17.558 17.6292L17.3306 18.8758C17.1457 19.8894 16.1918 20.5789 15.1656 20.4406L13.9036 20.2706C13.5419 20.2218 13.1775 20.3396 12.9137 20.5905L11.9932 21.4661C11.2447 22.178 10.0656 22.178 9.31711 21.4661L8.39656 20.5905C8.13274 20.3396 7.76842 20.2218 7.40672 20.2706L6.14466 20.4406Z",
    fill: "url(#paint0_linear_2670_49993)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.49984 9.50008H9.50817M14.4998 14.5001H14.5082M15.3332 8.66675L8.6665 15.3334M9.9165 9.50008C9.9165 9.7302 9.72996 9.91675 9.49984 9.91675C9.26972 9.91675 9.08317 9.7302 9.08317 9.50008C9.08317 9.26996 9.26972 9.08341 9.49984 9.08341C9.72996 9.08341 9.9165 9.26996 9.9165 9.50008ZM14.9165 14.5001C14.9165 14.7302 14.73 14.9167 14.4998 14.9167C14.2697 14.9167 14.0832 14.7302 14.0832 14.5001C14.0832 14.27 14.2697 14.0834 14.4998 14.0834C14.73 14.0834 14.9165 14.27 14.9165 14.5001Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2670_49993",
    x: 1,
    y: 2,
    width: 19.3103,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2670_49993"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2670_49993",
    x1: 1,
    y1: 4.08333,
    x2: 18.0833,
    y2: 19.0833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5388FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C48FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingPercent);
export default __webpack_public_path__ + "static/media/booking_percent.18a268fe1c78a0603598123b33c8eec9.svg";
export { ForwardRef as ReactComponent };